<template>
  <section class="tw-section">
    <div class="tw-container">
      <div class="tw-header">
        <div class="tw-title-row">
          <svg
            class="tw-icon"
            viewBox="64 80 36 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M96.9999 85V101.5C96.9999 102.296 96.6839 103.059 96.1213 103.621C95.5587 104.184 94.7956 104.5 93.9999 104.5C91.4949 104.5 86.5899 104.5 84.4449 106H96.9999C97.3978 106 97.7793 105.842 98.0606 105.561C98.3419 105.279 98.4999 104.898 98.4999 104.5V86.5C98.4999 86.1022 98.3419 85.7206 98.0606 85.4393C97.7793 85.158 97.3978 85 96.9999 85Z"
              fill="white"
            />
            <path
              d="M67 101.5V85C66.6022 85 66.2206 85.158 65.9393 85.4393C65.658 85.7206 65.5 86.1022 65.5 86.5V104.5C65.5 104.898 65.658 105.279 65.9393 105.561C66.2206 105.842 66.6022 106 67 106H79.555C77.425 104.5 72.505 104.5 70 104.5C69.2044 104.5 68.4413 104.184 67.8787 103.621C67.3161 103.059 67 102.296 67 101.5Z"
              fill="white"
            />
            <path
              d="M70 82C69.6022 82 69.2206 82.158 68.9393 82.4393C68.658 82.7206 68.5 83.1022 68.5 83.5V101.5C68.5 101.898 68.658 102.279 68.9393 102.561C69.2206 102.842 69.6022 103 70 103C74.4325 103 79.2925 103.225 81.25 105.528V84.04C78.5725 82.2025 74.11 82 70 82Z"
              fill="white"
            />
            <path
              d="M95.5 101.5V83.5C95.5 83.1022 95.342 82.7206 95.0607 82.4393C94.7794 82.158 94.3978 82 94 82C89.89 82 85.4275 82.2025 82.75 84.04V105.528C84.7075 103.225 89.5675 103 94 103C94.3978 103 94.7794 102.842 95.0607 102.561C95.342 102.279 95.5 101.898 95.5 101.5Z"
              fill="white"
            />
          </svg>
          <h2 class="tw-title-text">{{ t("home.taiwanStandard.title") }}</h2>
        </div>
      </div>

      <div class="tw-card">
        <h3 class="tw-card-title">{{ t("home.taiwanStandard.announcement.title") }}</h3>
        <p class="tw-card-body">{{ t("home.taiwanStandard.announcement.desc") }}</p>
        <router-link to="/standard-announcements" class="tw-btn">
          <span class="tw-btn-text">{{ t("home.taiwanStandard.announcement.btn") }}</span>
        </router-link>
      </div>

      <div class="tw-card">
        <h3 class="tw-card-title tw-card-title--sm">{{ t("home.taiwanStandard.dataset.title") }}</h3>
        <p class="tw-card-body">{{ t("home.taiwanStandard.dataset.desc") }}</p>
        <a
          href="https://medstandard.mohw.gov.tw/snomed-ct/data-set"
          target="_blank"
          rel="noopener noreferrer"
          class="tw-btn tw-btn--sm"
        >
          <span class="tw-btn-text tw-btn-text--sm">{{ t("home.taiwanStandard.dataset.btn") }}</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<style scoped>
.tw-section {
  background-color: #022964;
  width: 100%;
  padding: 48px 64px 60px;
  box-sizing: border-box;
}

.tw-container {
  max-width: 1152px;
  margin: 0 auto;
}

.tw-header {
  margin-bottom: 28px;
}

.tw-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
}

.tw-icon {
  width: 36px;
  height: 28px;
  flex-shrink: 0;
}

.tw-title-text {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  color: #ffffff;
}

.tw-card {
  background: #f9f9f9;
  border-radius: 20px;
  padding: 28px 32px 32px;
  margin-bottom: 16px;
  box-sizing: border-box;
}

.tw-card:last-child {
  margin-bottom: 0;
}

.tw-card-title {
  display: block;
  margin: 0 0 20px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
  color: #0D84F0;
}

.tw-card-title--sm {
  width: auto;
}

.tw-card-body {
  display: block;
  margin: 0 0 24px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  color: #333333;
  white-space: pre-wrap;
}

.tw-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #022964;
  border: none;
  border-radius: 17px;
  padding: 0 20px;
  height: 34px;
  cursor: pointer;
  min-width: 132px;
}

.tw-btn--sm {
  min-width: 104px;
}

.tw-btn-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: #ffffff;
  white-space: nowrap;
}

.tw-btn-text--sm {
  font-size: 14px;
}

@media (max-width: 768px) {
  .tw-section {
    padding: 36px 24px 48px;
  }

  .tw-icon {
    width: 28px;
    height: 22px;
  }

  .tw-title-text {
    font-size: 26px;
  }

  .tw-card {
    padding: 20px 20px 24px;
    border-radius: 16px;
    margin-bottom: 12px;
  }

  .tw-card-title {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .tw-card-body {
    font-size: 13px;
    margin-bottom: 20px;
  }

  .tw-btn {
    height: 30px;
    min-width: 110px;
    padding: 0 16px;
  }

  .tw-btn--sm {
    min-width: 88px;
  }

  .tw-btn-text {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .tw-section {
    padding: 28px 16px 36px;
  }
}
</style>
